import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-checkout',
  templateUrl: './test-checkout.component.html',
  styleUrls: ['./test-checkout.component.css']
})
export class TestCheckoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/test-checkout/test-checkout.component.ts